export default __webpack_public_path__ + "static/4-e255dab7aa6dd3fee161203d58126ff4.png";